// @flow strict-local

import * as React from 'react';

import {CancelApp} from './cancel.jsx';
import {RescheduleApp} from './reschedule.jsx';
import {BookingApp} from './booking.jsx';
import {SchedulerTimezonePicker} from './timezone-picker.jsx';
import {RsvpApp} from './rsvp.jsx';

import invariant from 'invariant';

import {captureSentryMessage} from 'src/utils/sentry';
import {isValidTimezone} from 'src/components/scheduler/lib/timezone-picker/utils.js';


export const StandaloneApp = ({
  agentId,
  templateSuffix,
}: {
  agentId?: string,
  templateSuffix: string,
}): React.Node => {
  // nb: tz is defined but we default to 'America/Los_Angeles'
  const provisionalTimezone: string =
    Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/Los_Angeles';
  const [timezone, setTimezone] = React.useState<string | null>(
    provisionalTimezone,
  );

  React.useEffect(() => {
    if (timezone !== null && !isValidTimezone(timezone)) {
      captureSentryMessage(`Invalid timezone: ${timezone}`, {
        level: 'error',
        tags: {product: 'scheduler', timezone},
      });
      setTimezone(null);
    }
  }, []);

  if (timezone == null) {
    invariant(agentId != null, 'need a valid template url');
    return (
      <SchedulerTimezonePicker
        onChangeTimezone={setTimezone}
        agentId={agentId || ''}
        templateSuffix={templateSuffix}
      />
    );
  }

  // NOTE (kyle): this is essentially a janky router
  return (
    <>
      {agentId === 'cancel' && (
        <CancelApp eventId={templateSuffix} timezone={timezone} />
      )}
      {agentId === 'reschedule' && (
        <RescheduleApp eventId={templateSuffix} timezone={timezone} />
      )}
      {agentId === 'rsvp' && (
        <RsvpApp eventId={templateSuffix} timezone={timezone} />
      )}
      {agentId !== 'cancel' &&
        agentId !== 'reschedule' &&
        agentId !== 'rsvp' &&
        timezone !== null && (
          <BookingApp
            timezone={timezone}
            agentId={agentId}
            templateSuffix={templateSuffix}
          />
        )}
    </>
  );
};
